// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import './assets/scss/main.scss';

// import * as serviceWorker from './serviceWorker';
// ReactDOM.render(<App />, document.getElementById('root'));

// serviceWorker.register();

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './assets/scss/main.scss';

// Forzar eliminación de Service Workers existentes para usuarios antiguos
if ('serviceWorker' in navigator) {
  // Primero desregistrar todos los SW existentes
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister().then(function(boolean) {
        console.log('Service Worker desregistrado:', boolean);
      });
    }
  });
  
  // Registrar temporalmente el SW "asesino" para limpiar caché
  navigator.serviceWorker.register('/sw-killer.js').then(function(registration) {
    console.log('SW Killer registrado para limpiar caché');
    // Después de un momento, desregistrar también este
    setTimeout(() => {
      registration.unregister();
    }, 5000);
  }).catch(function(error) {
    console.log('Error registrando SW Killer:', error);
  });
  
  // Limpiar todos los caches manualmente también
  if ('caches' in window) {
    caches.keys().then(function(names) {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}

ReactDOM.render(<App />, document.getElementById('root'));